import { isNumber } from 'lodash';
import isUTF8 from './IsUTF8';
import * as cptable from 'codepage/dist/cpexcel.full';

export const sheetToJson = ({ XLSX, result, isCSV, range }) => {
  const workbook = XLSX.read(result, { type: isCSV ? 'string' : 'binary', 'cellHTML': false, 'cellText': false, 'raw': true });
  // 存储获取到的数据
  let data = {};
  // 遍历每张工作表进行读取（这里默认只读取第一张表）
  for (const sheet in workbook.Sheets) {
    // fix: 老版本格式读取错误处理: 范围错误
    const _s = Object.keys(workbook.Sheets[sheet]).map(cellA => {
      const _c = cellA.match(/\d+/gm);
      return Array.isArray(_c) ? Number(_c[0]) : 0;
    });
    const _mr = Math.max(..._s);
    const _ref = workbook.Sheets[sheet]['!ref'].split(':');
    _ref[1] = _ref[1].replace(/\d+/g, _mr);
    workbook.Sheets[sheet]['!ref'] = _ref.join(':');
    let tempData = [];
    // esline-disable-next-line
    if (workbook.Sheets.hasOwnProperty(sheet)) {
      // 利用 sheet_to_json 方法将 excel 转成 json 数据
      if (range.hasOwnProperty(sheet)) {
        const tmp = XLSX.utils.sheet_to_json(workbook.Sheets[sheet], { range: range[sheet].start || 0, defval: '' });
        data[sheet] = tempData.concat(tmp.splice(0, tmp.length - (range[sheet].end || 0)));
      } else if (range.hasOwnProperty('start')) {
        const tmp = XLSX.utils.sheet_to_json(workbook.Sheets[sheet], { range: range.start || 0, defval: '' });
        data[sheet] = tempData.concat(tmp.splice(0, tmp.length - (range.end || 0)));
      } else {
        data[sheet] = tempData.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet], { range: 0, defval: '' })); // range: 0, defval: ''
      }
    }
  }
  return data;
}

export const csvRadStrategy = (data) => {
  data = new Uint8Array(data);
  let f = isUTF8(data);
  let r;
  if (!f) {
    r = cptable.utils.decode(936, data);
  } else {
    r = cptable.utils.decode(65001, data);
  }
  return r;
}

export const str_to_date_format = (date_num, false_return_now = true, format = '-') => {
  if ( ! date_num && !false_return_now) {
    return null;
  }
  if (isNumber(date_num)) {
    const old = date_num - 1;
    const t = Math.round((old - Math.floor(old)) * 24 * 60 * 60);
    const time = new Date(1900, 0, old, 0, 0, t)
    const year = time.getFullYear() ;
    const month = time.getMonth() + 1 ;
    const date = time.getDate() ;
    return `${year}${format}${month < 10 ? '0' + String(month) : month}${format}${date < 10 ? '0' + String(date) : date}`;
  }
  return date_num;
}
